import React from 'react';
import { DateTime } from 'luxon';
import * as moment from 'moment';
import { groupBy as _groupBy } from 'lodash';
import { REACT_APP_XMPP_SOCKET_HOST } from '../../Components/processENV';
import {
    blockOfflineAction,
    capitalizeFirstLetter,
    capitalizeTxt,
    fileToBlob,
    getArchiveSetting,
    getDbInstanceName,
    getFormatPhoneNumber,
    getLocalWebsettings,
    getMessageType,
    getUserIdFromJid,
    normalizeTime,
    sendNotification,
    setLocalWebsettings,
} from '../Utility';
import { Store } from '../../store';
import { IconUploading } from '../../assets/images';
import { resetRecentChat, ActiveChatResetAction, updateArchiveStatusRecentChat } from '../../Actions/RecentChatActions';
import { ResetUnreadCount } from '../../Actions/UnreadCount';
import { MEDIA_MESSAGE_TYPES } from '../Constants';
import { DELETE_MESSAGE_FOR_EVERYONE, DELETE_MESSAGE_FOR_ME } from '../../Actions/Constants';
import IndexedDb from '../../Helpers/IndexedDb';
import { CancelMediaUpload, ChatMessageHistoryDataAction, UpdateMediaUploadStatus } from '../../Actions/ChatHistory';
import SDK from '../../Components/SDK';
import { getExtension } from '../../Components/WebChat/Common/FileUploadValidation';
import {
    getFromLocalStorageAndDecrypt,
    encryptAndStoreInLocalStorage,
    getFromSessionStorageAndDecrypt,
    encryptAndStoreInSessionStorage,
} from '../../Components/WebChat/WebChatEncryptDecrypt';
import { getAvatarImage, groupAvatar } from '../../Components/WebChat/Common/Avatarbase64';
import { webSettingLocalAction } from '../../Actions/BrowserAction';
import Config from '../../config';
import { DownloadingChatMedia, MediaDownloadDataAction, MediaUploadDataAction } from '../../Actions/Media';
import { emojiUtils } from '../EmojiUtils';
import { getReactionPreviewText, getReactionTargetText } from '../../features/recentChat/previewText';
import { i18n } from '../../localization/i18n';
import logger from '../../Helpers/logger';
import { getGroupData } from './Group';
import { changeTimeFormat, msgStatusOrder } from './RecentChat';
import {
    formatGroupIdToJid,
    formatUserIdToJid,
    getContactNameFromRoster,
    getSenderIdFromMsgObj,
    isLocalUser,
    getDataFromRoster,
    getUserDetails,
} from './User';
import {
    CHAT_TYPE_SINGLE,
    MSG_SENT_ACKNOWLEDGE_STATUS_ID,
    MSG_SENT_ACKNOWLEDGE_STATUS,
    MSG_DELIVERED_STATUS_ID,
    MSG_DELIVERED_STATUS,
    MSG_DELIVERED_STATUS_CARBON,
    MSG_SEEN_STATUS_ID,
    MSG_SEEN_STATUS,
    MSG_SEEN_STATUS_CARBON,
    MSG_PROCESSING_STATUS_ID,
    MSG_PROCESSING_STATUS,
    CHAT_TYPE_GROUP,
    GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
    GROUP_DISAPPEAR_UPDATED,
    GROUP_PROFILE_INFO_UPDATED,
    CHAT_TYPE_BROADCAST,
    BRAND_NAME,
    REPORT_FROM_CONTACT_INFO,
} from './Constant';

const indexedDb = new IndexedDb();

const { reportMembers } = Config;

let uploadingFile = [];
export const notificationMessageType = ['1', '2', '3', '4', '5'];
export function formatBytes(a, b = 2) {
    if (0 === a) {
        return '0 Bytes';
    }
    const c = 0 > b ? 0 : b,
        d = Math.floor(Math.log(a) / Math.log(1024));
    return (
        parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
        ' ' +
        ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]
    );
}
export function convertTime(sec) {
    let hours = Math.floor(sec / 3600);
    if (hours >= 1) sec = sec - hours * 3600;
    else hours = 0;
    let min = Math.floor(sec / 60);
    if (min >= 1) sec = sec - min * 60;
    else min = '00';
    if (sec < 1) sec = '00';
    else void 0;

    if (min.toString().length === 1) min = '0' + min;
    else void 0;
    if (sec.toString().length === 1) sec = '0' + sec;
    else void 0;
    return hours ? hours + ':' + min + ':' + sec : min + ':' + sec;
}
export const getJidFromRencentChat = chatConversation => {
    const { roster, recent } = chatConversation;
    const { jid, username, msgfrom } = roster || recent || {};
    const updateJid = jid || username || msgfrom;
    return updateJid + '@' + REACT_APP_XMPP_SOCKET_HOST;
};

export const displayNameFromRencentChat = (roster = {}) => {
    const { displayName, name, nickName, jid, groupName } = roster || {};
    return displayName || groupName || name || nickName || jid;
};

export const displayNameFromRoster = (roster, _msgFrom) => {
    return getContactNameFromRoster(roster);
};

export const getNameFromGroup = group => {
    const { displayName } = group || {};
    return displayName || getContactNameFromRoster(group);
};

export const getDisplayNameFromGroup = (messageFrom = '', groupMemberDetails = []) => {
    const userId = messageFrom?.split('@')[0];
    let rosterObject = getDataFromRoster(userId);
    if (!rosterObject || Object.keys(rosterObject).length <= 1) {
        rosterObject = getUserDetails(userId);
    }

    if (rosterObject && Object.keys(rosterObject).length > 0) {
        const nameToDisplay = getContactNameFromRoster(rosterObject);
        const userColor = rosterObject?.userColor || 'black';

        return {
            nameToDisplay,
            userColor,
        };
    }
    return {
        nameToDisplay: getFormatPhoneNumber(userId),
        userColor: 'black',
    };
};

export const formatPhoneNumber = jid => {
    return getFormatPhoneNumber(jid);
};

export const getNamefromRoster = rosterObject => {
    const { displayName, name, nickName, jid } = rosterObject || {};
    return displayName || name || nickName || getFormatPhoneNumber(jid);
};

export const getNameAndStatus = (jid = '', roster = []) => {
    const userJid = jid.split('@')[0];
    return roster.find(profile => {
        const rosterJid = profile.username ? profile.username : profile.userId;
        return rosterJid === userJid;
    });
};

export const getBroadCastUser = (participants = [], totalContactList = []) => {
    const rosterContacts = totalContactList.filter(singleContact => {
        const rosterJid = singleContact.jid || singleContact.username;
        return participants.indexOf(rosterJid) !== -1;
    });

    return participants.map(groupMember => ({
        ...rosterContacts.find(singleContact => {
            const rosterJid = singleContact.jid || singleContact.username;
            if (rosterJid === groupMember) {
                return singleContact;
            }
        }),
        jid: groupMember,
    }));
};

export const handleParticipantList = (participants = [], totalContactList = []) => {
    return participants.map(groupMember => ({
        ...(getDataFromRoster(groupMember.userId) || {}),
        ...groupMember,
    }));
};

export const classNames = classes => {
    return Object.entries(classes)
        .filter(([_key, value]) => value)
        .map(([key, _value]) => key)
        .join(' ');
};

export const groupBy = (messageToGroup, callback) => {
    return messageToGroup.reduce((groups, message) => {
        const date = callback(message);
        groups[date] = [...(groups[date] || []), message];
        return groups;
    }, {});
};

export const groupByTime = (message, callback) => {
    const { res } = message.reduce(
        (messageGroup, singleImage, currentIndex, messageArray) => {
            const time = callback(singleImage);
            if (
                !messageGroup.currentTime ||
                messageGroup.currentTime - time > 60000 ||
                singleImage.msgtype !== messageGroup.messageType ||
                singleImage.fromUser !== messageGroup.fromUser
            ) {
                let newArray = [];
                messageGroup.res = [...messageGroup.res, newArray];
                messageGroup.currentArray = newArray;

                messageGroup.fromUser = singleImage.fromUser;
                messageGroup.messageType = singleImage.msgtype;
                messageGroup.currentTime = time;
            }
            const previousObject = messageArray[currentIndex - 1];
            messageGroup.previousMessageUser =
                previousObject && previousObject.msgType !== GROUP_CHAT_PROFILE_UPDATED_NOTIFY
                    ? getSenderIdFromMsgObj(previousObject)
                    : null;
            messageGroup.currentArray.push({
                ...singleImage,
                previousMessageUser: messageGroup.previousMessageUser,
                ...(singleImage?.chatType === 'groupchat' &&
                    !singleImage.publisherId && { publisherId: singleImage.fromUserId }),
            });
            return messageGroup;
        },
        { res: [] },
    );
    return res;
};

export const getCurrentTime = () => {
    return moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss');
};

/**
 * Labels the date divider of a message group (FR71 Screen 71.1).
 *
 * Buckets: Today, Yesterday, the previous 7 days by abbreviated weekday, then
 * "12 July" within this year and "12 July 2025" beyond it. Counting is done on
 * calendar days, so a message sent late yesterday evening is not labelled Today.
 *
 * @param {string} current_datetime Local date string of the group.
 * @returns {string} Divider label.
 */
const getlabel = current_datetime => {
    const dateObject = new Date(current_datetime.replace(/ /g, 'T'));
    const messageDay = moment(dateObject).startOf('day');
    const daysAgo = moment().startOf('day').diff(messageDay, 'days');

    if (daysAgo <= 0) {
        return i18n.t('chat.detail.TODAY');
    }
    if (daysAgo === 1) {
        return i18n.t('chat.detail.YESTERDAY');
    }
    if (daysAgo < 7) {
        return DateTime.fromJSDate(dateObject).toFormat('ccc');
    }
    // Spec spells the month out here — "12 July", not the abbreviation used elsewhere.
    if (dateObject.getFullYear() === new Date().getFullYear()) {
        return DateTime.fromJSDate(dateObject).toFormat('d LLLL');
    }
    return DateTime.fromJSDate(dateObject).toFormat('d LLLL yyyy');
};

export const convertDateFormat = dateString => {
    return getlabel(dateString);
};

export const deliveryStatus = {
    [MSG_SENT_ACKNOWLEDGE_STATUS_ID]: 'offline',
    [MSG_DELIVERED_STATUS_ID]: 'notsent',
    [MSG_SEEN_STATUS_ID]: 'sent',
    [MSG_PROCESSING_STATUS_ID]: 'processing',
};

export const isValidDeleteEveryOne = msgdate => {
    const date = new Date(msgdate.replace(/ /g, 'T'));
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    const now = new Date();
    const validTime = 30 * 1000;
    return now - newDate <= validTime;
};

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()];
};

export const concatMedia = (activeData, stateData) => {
    const updateMedia = [...[...activeData].reverse(), ...stateData];
    return getUniqueListBy(updateMedia, 'msgId');
};

export const concatMessageArray = (activeData, stateData, uniqueId, sortId) => {
    const updateMessage = [...stateData, ...activeData];
    return getUniqueListBy(updateMessage, uniqueId).sort((a, b) => {
        if (a[sortId] > b[sortId]) {
            return 1;
        } else if (a[sortId] < b[sortId]) {
            return -1;
        } else {
            return 0;
        }
    });
};

export const isSingleChat = chatType => chatType === CHAT_TYPE_SINGLE;
export const isGroupChat = chatType => chatType === CHAT_TYPE_GROUP;
export const isBroadcastChat = chatType => chatType === CHAT_TYPE_BROADCAST;
export const isSingleOrBroadcastChat = chatType => chatType === CHAT_TYPE_SINGLE || chatType === CHAT_TYPE_BROADCAST;
export const isSingleOrGroupChat = chatType => chatType === CHAT_TYPE_SINGLE || chatType === CHAT_TYPE_GROUP;

export const convertMsgStatusToStatusId = statusStr => {
    const msgStatusMap = {
        [MSG_DELIVERED_STATUS_CARBON]: MSG_DELIVERED_STATUS_ID,
        [MSG_DELIVERED_STATUS]: MSG_DELIVERED_STATUS_ID,
        [MSG_SEEN_STATUS]: MSG_SEEN_STATUS_ID,
        [MSG_SEEN_STATUS_CARBON]: MSG_SEEN_STATUS_ID,
        [MSG_SENT_ACKNOWLEDGE_STATUS]: MSG_SENT_ACKNOWLEDGE_STATUS_ID,
        [MSG_PROCESSING_STATUS]: MSG_PROCESSING_STATUS_ID,
    };
    return msgStatusMap[statusStr];
};

/**
 * Could check here active conversation screen chat type by giving the chat type as argument
 * @param {Boolean} chatType
 */
export const activeConversationChatType = chatType => {
    const { activeChatData: { data: { recent } = {} } = {} } = Store.getState();
    if (!chatType || !recent) return false;
    return recent.chatType === chatType;
};

/**
 * Get the active conversation user ID
 */
export const getActiveConversationChatId = () => {
    const { activeChatData } = Store.getState();
    return activeChatData?.data?.chatId;
};

/**
 * Get the active conversation user ID
 */
export const getActiveConversationChatJid = () => {
    const { activeChatData: { data: { chatJid } = {} } = {} } = Store.getState();
    return chatJid;
};

/**
 * Get the active conversation user Jid
 */
export const getActiveConversationUserJid = () => {
    const { activeChatData: { data: { chatId, chatType } = {} } = {} } = Store.getState();
    return formatUserIdToJid(chatId, chatType);
};

/**
 * Get all unread count data
 * @returns {Object} Unread data object with userId keys
 */
export const getUnreadData = () => {
    const state = Store.getState();
    // Callers index by userId, so return the inner map, not the slice wrapper.
    return state.unreadCountData?.unreadDataObj || {};
};

/**
 * Get the active conversation group ID
 */
export const getActiveConversationGroupId = () => {
    const { activeChatData: { data: { roster, recent } = {} } = {} } = Store.getState();
    let data = roster && Object.keys(roster).length > 0 ? roster : recent;
    return data?.groupId || recent?.fromUserId;
};

/**
 * Get the active conversation group Jid
 */
export const getActiveConversationGroupJid = () => {
    const groupId = getActiveConversationGroupId();
    return formatGroupIdToJid(groupId);
};

/**
 * Check the give USER or GROUP ID is in the active conversation screen
 * @param {string} userOrGroupId
 * @param {string} chatType
 */
export const isActiveConversationUserOrGroup = (userOrGroupId, chatType = CHAT_TYPE_SINGLE) => {
    if (!userOrGroupId) return false;
    const conversationUserOrGroupId = isSingleChat(chatType)
        ? getActiveConversationChatId()
        : getActiveConversationGroupId();
    userOrGroupId = getUserIdFromJid(userOrGroupId);
    return conversationUserOrGroupId === userOrGroupId;
};

/**
 * Return the user or group id based on active conversation
 */
export const getActiveConversationUserOrGroupId = () => {
    const isSingleChatActive = activeConversationChatType(CHAT_TYPE_SINGLE);
    if (isSingleChatActive) {
        return getActiveConversationChatId();
    }
    const isGroupChatActive = activeConversationChatType(CHAT_TYPE_GROUP);
    if (isGroupChatActive) {
        return getActiveConversationGroupId();
    }
    return undefined;
};

/**
 * Return the user or group JID based on active conversation
 */
export const getActiveConversationUserOrGroupJid = () => {
    const isSingleChatActive = activeConversationChatType(CHAT_TYPE_SINGLE);
    if (isSingleChatActive) {
        return getActiveConversationUserJid();
    }
    const isGroupChatActive = activeConversationChatType(CHAT_TYPE_GROUP);
    if (isGroupChatActive) {
        return getActiveConversationGroupJid();
    }
    return undefined;
};

/**
 * Check the message status in order by comparing the current & new status order index, then return the proper status
 * suppose If receive sent acknowledge after delivered status, then we sent delivered status.
 *
 * @param {*} currentStatus
 * @param {*} newStatus
 */
export const getMsgStatusInOrder = (currentStatus, newStatus) => {
    const currentStatusIndex = msgStatusOrder.indexOf(currentStatus);
    const newStatusIndex = msgStatusOrder.indexOf(newStatus);
    if (newStatusIndex > currentStatusIndex) {
        return newStatus;
    }
    return currentStatus;
};

/**
 * Chat conversation message status element
 * @param {*} status
 * @param {*} publisherId
 */
export const getMsgStatusEle = (status, seenReceipt, publisherId, singleChat) => {
    if (isLocalUser(publisherId)) {
        let updatedStatus = deliveryStatus[status];
        if (singleChat) {
            if (status === MSG_SEEN_STATUS_ID && seenReceipt === 0) {
                updatedStatus = 'notsent';
            } else if (seenReceipt === 0) {
                updatedStatus = 'offlinet';
            } else if (seenReceipt === '' || seenReceipt === null || seenReceipt === undefined) {
                updatedStatus = deliveryStatus[status];
            }
        } else {
            updatedStatus = deliveryStatus[status];
        }

        // data-status carries the resolved state to the footer, which draws the
        // tick from it rather than re-deriving it from the class string.
        return (
            <span className={`status ${updatedStatus}`} data-status={updatedStatus}>
                {status === MSG_PROCESSING_STATUS_ID && (
                    <i className="uploading">
                        <IconUploading />
                    </i>
                )}
            </span>
        );
    }
    return null;
};

/**
 * Reseting Store Data
 */
export const resetStoreData = () => {
    Store.dispatch(ActiveChatResetAction());
    Store.dispatch(ResetUnreadCount());
    Store.dispatch(resetRecentChat());
};

export const updateSessionIdInLocalStorage = () => {
    let currentTabId = getFromSessionStorageAndDecrypt('sessionId');
    currentTabId != null && encryptAndStoreInLocalStorage('sessionId', currentTabId);
};

export const isCurrentSessionActive = () =>
    getFromSessionStorageAndDecrypt('sessionId') === null ||
    getFromLocalStorageAndDecrypt('sessionId') == null ||
    getFromLocalStorageAndDecrypt('sessionId') === getFromSessionStorageAndDecrypt('sessionId');

export const updateSessionId = tabId => {
    if (getFromSessionStorageAndDecrypt('sessionId') === null) {
        encryptAndStoreInSessionStorage('sessionId', tabId);
        encryptAndStoreInLocalStorage('sessionId', tabId);
    }
};

export const isTextMessage = msgType => {
    if (!msgType) return false;
    return ['text', 'auto_text'].indexOf(msgType) > -1;
};

export const isMeetMessage = msgType => {
    if (!msgType) return false;
    return ['meet'].indexOf(msgType) > -1;
};

export const isChannelInviteMessage = msgType => {
    if (!msgType) return false;
    return ['channelInvitation'].indexOf(msgType) > -1;
};

export const isSameSession = () => {
    return getFromLocalStorageAndDecrypt('sessionId') === getFromSessionStorageAndDecrypt('sessionId');
};

export const updateFavicon = type => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = type === 'error' ? '../../favicon-error.png' : '../../favicon.png';
};

export const isMediaMessage = (msgBody = {}) => MEDIA_MESSAGE_TYPES.includes(msgBody.message_type);

export const arrayToObject = (arr, key) => {
    return arr.reduce((obj, item) => {
        obj[item[key]] = item;
        return obj;
    }, {});
};

export const getChatHistoryData = (data, stateData) => {
    // To Avoid Unnecessary Looping, We are Using Key Value Pair for Chat and Messages
    // Eg: userId: {} or groupId: {} or msgId: {}
    const chatId = getUserIdFromJid(data.userJid || data.groupJid);
    const shouldReplaceState = data.data.reconnectFetch === 1;

    let state = {};
    if (shouldReplaceState) {
        const existingMessages = stateData[chatId]?.messages || {};
        // Preserve unsent messages AND synthetic disappear notification banners.
        // Banners are client-side only (server never stores them), so they would be
        // permanently lost after reconnect without this guard.
        const preserved = Object.values(existingMessages).filter(
            msg =>
                msg.msgStatus === 3 ||
                (msg.profileUpdatedStatus === GROUP_DISAPPEAR_UPDATED &&
                    typeof msg.msgId === 'string' &&
                    (msg.msgId.endsWith('_disappear') || msg.msgId.endsWith('_single_disappear'))),
        );
        state = preserved.reduce((acc, msg) => {
            acc[msg.msgId] = msg;
            return acc;
        }, {});
    } else if (Object.keys(stateData).length > 0 && data.data.historyEnabledUser !== 1) {
        state = stateData[chatId]?.messages || {};
    }
    if (data.data && Array.isArray(data.data)) {
        data.data = data.data.map(msg => ({
            ...msg,
            reactions: transformReactionsGrouped(msg.reactions),
        }));
    }

    // A cached disappear banner and the server's copy of the same event would both show;
    // the server copy is dropped. Real-time events are new, so never compared.
    if (!data.realTimeUpdate && Array.isArray(data.data) && Object.keys(state).length > 0) {
        const disappearBannerTs = new Set(
            Object.values(state)
                .filter(
                    m =>
                        m.profileUpdatedStatus === GROUP_DISAPPEAR_UPDATED &&
                        typeof m.msgId === 'string' &&
                        m.msgId.endsWith('_disappear'),
                )
                .map(m => {
                    // Strip '_single_disappear' OR '_disappear' suffix to recover the raw timestamp.
                    const tsStr = m.msgId.replace(/_(?:single_)?disappear$/, '');
                    return Number(tsStr);
                })
                .filter(ts => !isNaN(ts)),
        );
        if (disappearBannerTs.size > 0) {
            data.data = data.data.filter(msg => {
                if (msg.msgType !== GROUP_CHAT_PROFILE_UPDATED_NOTIFY) return true;
                // Group chats: only timer events (or the generic profile one) can copy a banner.
                // Single chats: every profile event is a timer event.
                const isGroupMsg = !!getGroupData(formatUserIdToJid(msg.fromUserId, CHAT_TYPE_GROUP));
                const isTimerEvent = [GROUP_PROFILE_INFO_UPDATED, GROUP_DISAPPEAR_UPDATED].includes(
                    msg.profileUpdatedStatus,
                );
                if (isGroupMsg && !isTimerEvent) return true;
                const ts = Number(msg.timestamp);
                // Match within 30 s to absorb network round-trip delay between the
                // client's pre-SDK-call Date.now() and the server's stored event time.
                // Also handles ms vs µs representation differences.
                const WINDOW_MS = 30000;
                return ![...disappearBannerTs].some(bts => {
                    const tMs = ts.toString().length >= 16 ? Math.floor(ts / 1000) : ts;
                    const bMs = bts.toString().length >= 16 ? Math.floor(bts / 1000) : bts;
                    return Math.abs(bMs - tMs) <= WINDOW_MS;
                });
            });
        }
    }

    const sortedData = concatMessageArray(data.data, Object.values(state), 'msgId', 'timestamp');
    const lastMessage = sortedData[sortedData.length - 1];
    let newSortedData;
    const localUserJid = getFromLocalStorageAndDecrypt('loggedInUserJidWithResource');
    const userId = localUserJid ? getUserIdFromJid(localUserJid) : '';
    if (userId === lastMessage?.publisherId) {
        newSortedData = sortedData.map(msg => {
            const currentMessage = data?.data[data?.data.length - 1];
            if (currentMessage?.editedStatus === 1 && currentMessage?.msgId === msg?.msgId) {
                msg.msgStatus = getMsgStatusInOrder(msg.msgStatus, currentMessage?.msgStatus);
            } else {
                msg.msgStatus = getMsgStatusInOrder(msg.msgStatus, lastMessage?.msgStatus);
            }
            return msg;
        });
    } else {
        newSortedData = sortedData;
    }

    let isScrollNeeded = true;
    if (data.fetchLimit) {
        isScrollNeeded = data.data.length === data.fetchLimit; // To Check If this is the Last Message in the Chat, So no Scroll Fetch is Needed
    }
    const finalData = { isScrollNeeded, messages: arrayToObject(newSortedData, 'msgId') };

    return {
        ...stateData,
        [chatId]: finalData,
    };
};

export const clearChatHistoryOffline = (data, stateData) => {
    let chatData = stateData;
    const chatIds = Object.keys(chatData);
    const userId = data.fromUserId;
    const lastMessageId = data.lastMsgId;

    if (chatIds.includes(userId)) {
        let userOrGroupId = '';
        for (const chatId in chatData) {
            if (chatId === userId) {
                userOrGroupId = chatId;
            }
        }
        const chatMessages = chatData[userOrGroupId]?.messages;
        if (chatMessages[lastMessageId] !== undefined || '') {
            const timestamp = chatMessages[lastMessageId].timestamp;
            for (let msg in chatMessages) {
                if (data.favourite === '1') {
                    if (chatMessages[msg].timestamp <= timestamp) {
                        if (chatMessages[msg].favouriteStatus === 0) {
                            delete chatMessages[msg];
                        }
                    }
                } else if (chatMessages[msg].timestamp <= timestamp) {
                    delete chatMessages[msg];
                }
            }
            return chatMessages;
        }
    }
};

export const getChatHistoryMessagesData = () => {
    const { chatConversationHistory: { data } = {} } = Store.getState();
    return data;
};

export const getRecentChatMessagesData = () => {
    const { recentChatData: { data } = {} } = Store.getState();
    return data;
};

export const getChatMessageHistoryById = id => {
    const { chatConversationHistory: { data } = {} } = Store.getState();
    if (data[id]?.messages) return Object.values(data[id]?.messages);
    return [];
};

const msgTypeToBucket = {
    delivered: 'delivered',
    carbonDelivered: 'delivered',
    seen: 'read',
    carbonSeen: 'read',
};

export const getUpdatedHistoryData = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const chatKey = getUserIdFromJid(data.fromUserId || data.userJid || '');
    const currentChatData = stateData[chatKey];
    const msgIds = currentChatData?.messages ? Object.keys(currentChatData?.messages) : {};

    if (msgIds.length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            const msgStatus = getMsgStatusInOrder(currentMessage.msgStatus, data.msgStatus);
            currentMessage.msgStatus = msgStatus;
            const STATUS_TYPES = [
                'Processing',
                'delivered',
                'carbonDelivered',
                'seen',
                'carbonSeen',
                'acknowledge',
                'carbonSentSeen',
            ];
            if (data.msgType && !STATUS_TYPES.includes(data.msgType)) {
                currentMessage.msgType = data.msgBody?.msgType;
            }
            if (currentMessage?.msgBody?.media && data.msgType === 'acknowledge') {
                currentMessage.msgBody.media.is_uploading = 2;
            }

            // ---------------- NEW INSERTED LOGIC ----------------
            if (msgTypeToBucket[data.msgType]) {
                const bucketKey = msgTypeToBucket[data.msgType];

                if (!currentMessage?.deliveryAndReadInfo?.length) {
                    currentMessage.deliveryAndReadInfo = [
                        {
                            read: [],
                            delivered: [],
                        },
                    ];
                }

                const infoObj = currentMessage.deliveryAndReadInfo[0];

                const formattedEntry = {
                    userid: data.fromUserId,
                    thumbImage: '',
                    timestamp: new Date(data.timestamp).toISOString(),
                    epochTimestamp: data.timestamp,
                    formattedTime: new Date(data.timestamp).toLocaleString(),
                };
                infoObj[bucketKey].push(formattedEntry);
            }
            // ---------------- END NEW LOGIC ---------------------

            // Updating Old Msg Statuses to Current Status
            // const currentMessageIndex = msgIds.indexOf(data.msgId);
            // for (let i = 0; i < msgIds.length && i <= currentMessageIndex; i++) {
            //     const message = currentChatData?.messages[msgIds[i]];
            //     currentChatData.messages[msgIds[i]] = {
            //         ...message,
            //         ...(message.msgStatus !== 3 && message.msgStatus !== 0 && {
            //             msgStatus: getMsgStatusInOrder(message.msgStatus, msgStatus)
            //         })
            //     };
            // }

            return {
                ...stateData,
                [chatKey]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage,
                },
            };
        }
    }
    return {
        ...stateData,
    };
};

export const getUpdatedHistoryDataUpload = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const chatKey = getUserIdFromJid(data.fromUserId || data.userJid || '');
    const currentChatData = stateData[chatKey];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];

        if (currentMessage) {
            currentMessage.msgBody.media.is_uploading = data.uploadStatus;
            if (data.statusCode === 200) {
                currentMessage.msgBody.media.file_url = data.fileToken || '';
                currentMessage.msgBody.media.thumb_image = data.thumbImage || '';
                currentMessage.msgBody.media.file_key = data.fileKey || '';
            }
            return {
                ...stateData,
                [chatKey]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage,
                },
            };
        }
    }
    return {
        ...stateData,
    };
};

export const updateDeletedMessageInHistory = (actionType, data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];

    if (currentChatData) {
        if (actionType === DELETE_MESSAGE_FOR_ME) {
            data.msgIds.forEach(msgId => delete currentChatData.messages[msgId]);
        } else if (actionType === DELETE_MESSAGE_FOR_EVERYONE) {
            const messageIds = data.msgId.split(',');
            for (const msgId of messageIds) {
                if (currentChatData.messages[msgId]) {
                    currentChatData.messages[msgId].deleteStatus = 2;
                }
            }
        }

        return {
            ...stateData,
            [data.fromUserId]: {
                ...currentChatData,
            },
        };
    }
    return {
        ...stateData,
    };
};

export const getActiveChatMessages = () => {
    const chatId = getActiveConversationChatId();
    const { chatConversationHistory: { data } = {}, recentChatData } = Store.getState();
    if (data[chatId]?.messages) return Object.values(data[chatId]?.messages);
    else {
        const conversationChatObj = recentChatData.data.find(item => item.userId === chatId);
        if (conversationChatObj) {
            const singleChat = isSingleChat(conversationChatObj.chatType);
            const newChatTo =
                conversationChatObj.msgType === 'carbonSentMessage'
                    ? conversationChatObj.toUserId
                    : conversationChatObj.fromUserId;
            const dispatchData = {
                data: [conversationChatObj],
                ...(singleChat
                    ? { userJid: formatUserIdToJid(newChatTo) }
                    : { groupJid: formatUserIdToJid(newChatTo, CHAT_TYPE_GROUP) }),
            };
            Store.dispatch(ChatMessageHistoryDataAction(dispatchData));
        }
    }
    return [];
};

export const getLastMsgFromHistoryById = chatId => {
    const chatMessages = getChatMessageHistoryById(chatId);
    return chatMessages.length > 0 ? chatMessages[chatMessages.length - 1] : '';
};

export const getMessageFromHistoryById = (chatId, msgId) => {
    const { chatConversationHistory: { data } = {} } = Store.getState();
    if (data[chatId]?.messages && Object.keys(data[chatId]?.messages).length > 0) {
        return data[chatId]?.messages[msgId] || {};
    }
    return {};
};

export const getActiveChatUserRoster = () => {
    const { activeChatData: { data: { roster } = {} } = {} } = Store.getState();
    return roster;
};

export const updateMediaUploadStatus = (data, stateData) => {
    return stateData.map(el => {
        if (el.msgId === data.msgId) {
            return {
                ...el,
                uploadStatus: 1,
            };
        }
        return el;
    });
};

export const uploadFileSuccess = (msgId, jid, response) => {
    let updateObj = {
        msgId,
        statusCode: 200,
        fromUserId: getUserIdFromJid(jid),
    };
    updateObj.fileToken = response.msgBody.media.fileToken;
    updateObj.thumbImage = response.msgBody.media.thumbImage;
    updateObj.fileKey = response.msgBody.media.file_key;
    Store.dispatch(UpdateMediaUploadStatus(updateObj));
};

export const uploadFileFailure = (msgId, jid) => {
    const cancelObj = {
        msgId,
        fromUserId: getUserIdFromJid(jid),
        uploadStatus: 3,
        mediaUploading: true,
        mediaUploadCanceled: true,
    };
    Store.dispatch(CancelMediaUpload(cancelObj));
};

// REACT_APP_DISAPPEAR_TEST_MODE=true (dev/QA only):
//   disappear_at is computed with short durations for fast testing:
//   1 day (24h) → 1 min, 7 days → 3 min, 90 days → 5 min
// Values stored/sent to the server are unchanged in both modes (1, 7, 90).
const DISAPPEAR_TEST_MODE = process.env.REACT_APP_DISAPPEAR_TEST_MODE === 'true';

// Maps production day-values → test duration in minutes (only used when DISAPPEAR_TEST_MODE=true)
const TEST_MODE_MINUTES = { 1: 1, 7: 3, 90: 5 };

const formatDisappearAt = date => {
    const pad = n => String(n).padStart(2, '0');
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
};

export const resolveDisappearAt = (chatType, chatId) => {
    const state = Store.getState();
    let disappearValue = 0;
    if (isSingleChat(chatType)) {
        // 1. VCardContactData — only trusted when it holds THIS contact's profile.
        const contactData = state.VCardContactData?.data || {};
        const contactVal = contactData.userId === chatId ? Number(contactData.msgDisappear) : 0;
        if (contactVal > 0) {
            disappearValue = contactVal;
        }

        // 2. recentChatData — server sends msgDisappear per chat; loaded on every startup
        //    before the user can type, so it survives getUserProfile wiping vCardData.
        if (!disappearValue) {
            const recentChats = state.recentChatData?.data || [];
            const recentChat = recentChats.find(c => {
                const id = c.fromUserId?.includes('@') ? c.fromUserId.split('@')[0] : c.fromUserId;
                return id === chatId;
            });
            const recentVal = Number(recentChat?.msgDisappear) || 0;
            if (recentVal > 0) disappearValue = recentVal;
        }

        // 3. rosterData — populated by getFriendsList() on login.
        if (!disappearValue) {
            const rosterUsers = state.rosterData?.data || [];
            const rosterUser = rosterUsers.find(u => {
                const uid = u.userId?.includes('@') ? u.userId.split('@')[0] : u.userId;
                return uid === chatId;
            });
            const rosterVal = Number(rosterUser?.msgDisappear) || 0;
            if (rosterVal > 0) disappearValue = rosterVal;
        }

        // 4. vCardData (own account-level setting, restored from localStorage in userProfileListener).
        if (!disappearValue) {
            disappearValue = Number(state.vCardData?.data?.msgDisappear) || 0;
        }

        // 5. localStorage — per-contact map (set via ContactInfo) or global setting (Privacy Settings).
        //    Direct read catches the case where none of the Redux stores had the value yet.
        if (!disappearValue) {
            try {
                const perContact = JSON.parse(localStorage.getItem('_daz_contact_msg_disappear') || '{}');
                const perContactVal = Number(perContact[chatId]) || 0;
                if (perContactVal > 0) {
                    disappearValue = perContactVal;
                } else {
                    const stored = localStorage.getItem('_daz_own_msg_disappear');
                    if (stored !== null) disappearValue = Number(stored) || 0;
                }
            } catch (_) {}
        }
    } else if (isGroupChat(chatType)) {
        const groups = state.groupsData?.data || [];
        const group = groups.find(g => g.userId === chatId || g.groupId === chatId);
        disappearValue = Number(group?.msgDisappear) || 0;
    }

    if (!disappearValue) return undefined;
    const expiry = new Date();
    if (DISAPPEAR_TEST_MODE) {
        // In test mode shorten expiry so QA can verify without waiting days.
        // Server value is unchanged (1/7/90); only the timestamp offset is shortened.
        const minutes = TEST_MODE_MINUTES[disappearValue] ?? disappearValue;
        expiry.setTime(expiry.getTime() + minutes * 60 * 1000);
    } else {
        expiry.setUTCDate(expiry.getUTCDate() + disappearValue);
    }
    return formatDisappearAt(expiry);
};

export const uploadFileToSDK = async (file, jid, msgId) => {
    const {
        caption = '',
        mentionedUsersIds = [],
        batchId = null,
        batchImages = 0,
        batchVideos = 0,
        fileDetails: { replyTo, audioType = '' } = {},
    } = file;
    const { privacySettingsData } = Store.getState();
    const chatType = jid && jid.includes('mix.') ? CHAT_TYPE_GROUP : CHAT_TYPE_SINGLE;
    const chatId = getUserIdFromJid(jid);
    const seenReceipt = privacySettingsData.seenReceipt === 0 ? '0' : '1';
    const disappear_at = resolveDisappearAt(chatType, chatId);
    const msgType = getMessageType(file.type, file);
    let fileOptions = {
        file: file,
        msgId: msgId,
        caption: caption,
        ...(batchId && { batchId, batchImages, batchVideos }),
    };
    if (msgType === 'file') {
        await SDK.sendMediaFileMessage(
            {
                toJid: jid,
                messageType: 'file',
                fileMessageParams: fileOptions,
                mentionedUsersIds: mentionedUsersIds,
                replyMessageId: replyTo,
                receipt_status: seenReceipt,
                ...(disappear_at !== undefined && { disappear_at }),
            },
            msgId => {
                const fileUploadingData = { msgId, uploading: true };
                Store.dispatch(MediaUploadDataAction(fileUploadingData));
            },
            response => {
                uploadFileSuccess(response.msgId, jid, response);
            },
            _error => {
                uploadFileFailure(msgId, jid);
            },
        );
    } else if (msgType === 'image') {
        uploadingFile.push(fileOptions);
        await SDK.sendMediaFileMessage(
            {
                toJid: jid,
                messageType: 'image',
                fileMessageParams: fileOptions,
                mentionedUsersIds: mentionedUsersIds,
                replyMessageId: replyTo,
                receipt_status: seenReceipt,
                ...(disappear_at !== undefined && { disappear_at }),
            },
            msgId => {
                const imageUploadingData = { msgId, uploading: true };
                Store.dispatch(MediaUploadDataAction(imageUploadingData));
            },
            async response => {
                uploadFileSuccess(response.msgId, jid, response);
                const uploadedImage = uploadingFile.find(item => item.msgId === response.msgId);
                const imgFileBlob = await fileToBlob(uploadedImage.file);
                indexedDb.setImage(response.msgBody.media.fileToken, imgFileBlob, getDbInstanceName(msgType));
                uploadingFile = uploadingFile.filter(item => item.msgId !== response.msgId);
            },
            _error => {
                uploadFileFailure(msgId, jid);
            },
        );
    } else if (msgType === 'video') {
        uploadingFile.push(fileOptions);
        await SDK.sendMediaFileMessage(
            {
                toJid: jid,
                messageType: 'video',
                fileMessageParams: fileOptions,
                mentionedUsersIds: mentionedUsersIds,
                replyMessageId: replyTo,
                receipt_status: seenReceipt,
                ...(disappear_at !== undefined && { disappear_at }),
            },
            msgId => {
                const videoUploadingData = { msgId, uploading: true };
                Store.dispatch(MediaUploadDataAction(videoUploadingData));
            },
            async response => {
                uploadFileSuccess(response.msgId, jid, response);
                const uploadedVideo = uploadingFile.find(item => item.msgId === response.msgId);
                const videoFileBlob = await fileToBlob(uploadedVideo.file);
                indexedDb.setImage(response.msgBody.media.fileToken, videoFileBlob, getDbInstanceName(msgType));
                uploadingFile = uploadingFile.filter(item => item.msgId !== response.msgId);
            },
            _error => {
                uploadFileFailure(msgId, jid);
            },
        );
    } else if (msgType === 'audio') {
        uploadingFile.push(fileOptions);
        await SDK.sendMediaFileMessage(
            {
                toJid: jid,
                messageType: audioType === 'recording' ? 'audio_recorded' : 'audio',
                fileMessageParams: fileOptions,
                mentionedUsersIds: mentionedUsersIds,
                replyMessageId: replyTo,
                receipt_status: seenReceipt,
                ...(disappear_at !== undefined && { disappear_at }),
            },
            msgId => {
                const audioUploadingData = { msgId, uploading: true };
                Store.dispatch(MediaUploadDataAction(audioUploadingData));
            },
            async response => {
                uploadFileSuccess(response.msgId, jid, response);
                const uploadedAudio = uploadingFile.find(item => item.msgId === response.msgId);
                const audioFileBlob = await fileToBlob(uploadedAudio.file);
                indexedDb.setImage(response.msgBody.media.fileToken, audioFileBlob, getDbInstanceName(msgType));
                uploadingFile = uploadingFile.filter(item => item.msgId !== response.msgId);
            },
            _error => {
                uploadFileFailure(msgId, jid);
            },
        );
    }
};

export const updateMediaUploadStatusHistory = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            currentMessage.msgBody.media.is_uploading = data.uploadStatus;
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage,
                },
            };
        }
    }
    return {
        ...stateData,
    };
};

export const updateFavouriteStatusHistory = (data, stateData) => {
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData) {
        if (data.msgId) {
            const message = currentChatData?.messages[data.msgId];
            currentChatData.messages[data.msgId] = { ...message, favouriteStatus: data.favouriteStatus };
        } else if (data.msgIds?.length) {
            for (const msgId of data.msgIds) {
                const message = currentChatData?.messages[msgId];
                currentChatData.messages[msgId] = { ...message, favouriteStatus: data.favouriteStatus };
            }
        }
        return {
            ...stateData,
            [data.fromUserId]: {
                ...currentChatData,
            },
        };
    }
    return {
        ...stateData,
    };
};

export const removeFavouriteStatusHistory = (data, stateData) => {
    // Here We are Removing Starred Status in Conversation History of Each Opened Chat
    const duplicateState = JSON.parse(JSON.stringify(stateData));
    const groupByResult = _groupBy(data, 'fromUserId');
    const chatIds = Object.keys(groupByResult);
    for (let chatId of chatIds) {
        const currentChat = stateData[chatId];
        if (currentChat) {
            const unStarredMessages = groupByResult[chatId];
            const msgIds = unStarredMessages.map(msg => msg.msgId);
            for (const msgId of msgIds) {
                const currentMsg = currentChat.messages[msgId];
                if (currentMsg) duplicateState[chatId].messages[msgId] = { ...currentMsg, favouriteStatus: 0 };
            }
        }
    }
    return {
        ...duplicateState,
    };
};

export const getDownloadFileName = (file_url, msgType) => {
    const time = `${moment().format('YYYY-MM-DD')} at ${moment().format('hh.mm.ss A')}`;
    const extension = getExtension(file_url);
    const fileType = msgType === 'audio' ? 'ptt' : msgType;
    return `${BRAND_NAME} ${capitalizeFirstLetter(fileType)} ${time}${extension}`;
};

export const downloadMediaFile = async (filemsgId, file_Url, msgType, file_name, fileKey, event) => {
    if (blockOfflineAction()) return;
    Store.dispatch(
        DownloadingChatMedia({
            downloadMediaMsgId: filemsgId,
            downloadingFile: file_Url,
            downloading: true,
            downloadingMediaType: msgType,
        }),
    );
    if (file_Url) {
        const fileName = msgType === 'file' ? file_name : getDownloadFileName(file_Url, msgType);
        let fileUrl = file_Url;
        // For Downloading Live File with Original Name
        if (file_Url.search('blob:') === -1) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            await SDK.downloadMedia(
                filemsgId,
                res => {
                    Store.dispatch(MediaDownloadDataAction(res));
                },
                mediaResponse => {
                    Store.dispatch(
                        DownloadingChatMedia({
                            downloadMediaMsgId: filemsgId,
                            downloadingFile: file_Url,
                            downloading: false,
                            downloadingMediaType: msgType,
                        }),
                    );
                    fileUrl = mediaResponse.blobUrl;
                    const anchor = document.createElement('a');
                    anchor.style.display = 'none';
                    anchor.href = fileUrl;
                    anchor.setAttribute('download', fileName);
                    document.body.appendChild(anchor);
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    document.body.removeChild(anchor);
                    Store.dispatch(
                        DownloadingChatMedia({
                            downloadMediaMsgId: filemsgId,
                            downloadingFile: file_Url,
                            downloading: false,
                            downloadingMediaType: msgType,
                        }),
                    );
                    Store.dispatch(MediaDownloadDataAction({ msgId: filemsgId, progress: null }));
                },
                error => {
                    logger.debug('error in downloading media file', error);
                },
            );
        } else {
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = fileUrl;
            anchor.setAttribute('download', fileName);
            document.body.appendChild(anchor);
            anchor.click();
            window.URL.revokeObjectURL(anchor.href);
            document.body.removeChild(anchor);
            Store.dispatch(
                DownloadingChatMedia({
                    downloadMediaMsgId: filemsgId,
                    downloadingFile: file_Url,
                    downloading: false,
                    downloadingMediaType: msgType,
                }),
            );
        }
    }
};

export const updateStarredList = (data, stateData = [], originalMsg = {}) => {
    let newState = [...stateData];
    const index = stateData.findIndex(el => el.msgId === data.msgId);
    if (index > -1) {
        if (data.favouriteStatus === 0) newState.splice(index, 1);
        else if (data?.favouriteStatus === 1 && originalMsg?.editedStatus === 1) {
            //Edited content instant update in starred message
            const updatednewStateArr = newState;
            const findedItemIndex = updatednewStateArr?.findIndex(item => item?.msgId === originalMsg?.msgId);
            const isCaption = newState[findedItemIndex]?.msgBody?.media?.caption || '';
            let constructObj = {};
            if (isCaption !== '') {
                constructObj = {
                    ...newState[findedItemIndex],
                    msgBody: {
                        ...newState[findedItemIndex].msgBody,
                        media: {
                            ...newState[findedItemIndex].msgBody.media,
                            caption: originalMsg?.msgBody?.media?.caption,
                        },
                    },
                    editedStatus: originalMsg?.editedStatus,
                };
            } else {
                constructObj = {
                    ...newState[findedItemIndex],
                    msgBody: {
                        ...newState[findedItemIndex].msgBody,
                        message: originalMsg?.msgBody?.message,
                    },
                    editedStatus: originalMsg?.editedStatus,
                };
            }
            newState[findedItemIndex] = constructObj;
        }
    } else if (data.favouriteStatus === 1) {
        newState.push(originalMsg);
    }

    return newState;
};

export const getFavaouriteMsgObj = (msg, chatId) => {
    const publisherId = Store.getState().vCardData?.data?.fromUser;
    const isValidPublisherJid = publisherId === msg?.fromUserId ? publisherId : msg.publisherId;
    return {
        ...msg,
        favDate: changeTimeFormat(Date.now() * 1000),
        msgType: msg?.msgBody?.message_type,
        ...(isSingleChat(msg.chatType) && {
            publisherId: msg.publisherId || (publisherId === msg?.fromUserId ? publisherId : msg.fromUserId),
            publisherJid: formatUserIdToJid(msg?.publisherId ? msg.publisherId : isValidPublisherJid),
            fromUserId: chatId,
            fromUserJid: formatUserIdToJid(chatId),
        }),
        ...(isGroupChat(msg.chatType) && {
            publisherId: msg.publisherId || (publisherId === msg?.fromUserId ? publisherId : msg.publisherId),
            publisherJid: formatUserIdToJid(msg?.publisherId ? msg.publisherId : isValidPublisherJid),
            fromUserId: chatId,
            fromUserJid: formatUserIdToJid(chatId, msg.chatType),
        }),
    };
};

export const getBlobUrlFromToken = (fileToken, dbInstance, fileKey, msgId) => {
    return indexedDb
        .getImageByKey(fileToken, dbInstance, fileKey, msgId)
        .then(blob => window.URL.createObjectURL(blob))
        .catch(() => '');
};

export const updateMessageTranslate = (data, stateData) => {
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            currentMessage.msgBody.translatedMessage = data.translatedMessage;
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage,
                },
            };
        }
    }
    return {
        ...stateData,
    };
};

export const getAllStarredMessages = () => {
    const { starredMessages: { data = [] } = {} } = Store.getState();
    return data;
};

export const updatedStarredMessageStatus = (data, stateData = []) => {
    return stateData.map(msg => {
        if (msg.msgId === data.msgId) {
            msg.msgStatus = getMsgStatusInOrder(msg.msgStatus, data.msgStatus);
        }
        return msg;
    });
};

export const getMutedChats = () => {
    const { recentChatData: { data = [] } = {} } = Store.getState();
    const chatIds = [];
    data.forEach(recent => {
        if (recent.muteStatus === 1) chatIds.push(recent.fromUserId);
    });
    return chatIds;
};

export const getArchivedChats = () => {
    const { recentChatData: { data = [] } = {} } = Store.getState();
    const chatIds = [];
    data.forEach(recent => {
        if (recent.archiveStatus === 1) chatIds.push(recent.fromUserId);
    });
    return chatIds;
};

export const getPushNotificationData = async data => {
    let title = '',
        imageToken = '',
        updateMessage = '';
    const {
        fromUserId = '',
        publisherId = '',
        chatType = '',
        msgBody: { message = '', message_type = '' } = {},
    } = data;

    try {
        updateMessage = isTextMessage(message_type) ? message : `${capitalizeTxt(message_type)}`;

        if (isSingleChat(chatType)) {
            const roster = getUserDetails(fromUserId) || {};
            const { displayName, image, thumbImage } = roster;
            title = displayName || '';
            imageToken = thumbImage && thumbImage !== '' ? thumbImage : image;
        } else {
            const groupData = getGroupData(fromUserId) || {};
            const { groupName, groupImage, thumbImage } = groupData;
            title = groupName || '';
            imageToken = thumbImage && thumbImage !== '' ? thumbImage : groupImage;
            const senderName = getContactNameFromRoster(getDataFromRoster(publisherId)) || publisherId;
            updateMessage = `${senderName}: ${updateMessage}`;
        }

        if (data.msgType === 'msg_reaction') {
            const { reactionEmojiId = '', reactionType } = data;
            const reactorId = (reactionType !== 'chat' ? publisherId || fromUserId : fromUserId).replace(/@.*/, '');
            updateMessage = getReactionPreviewText({
                isGroup: !isSingleChat(chatType),
                reactorName: getContactNameFromRoster(getDataFromRoster(reactorId)) || reactorId,
                emojiChar: emojiUtils.getEmojiById(reactionEmojiId)?.char || '',
                targetText: getReactionTargetText(message_type, data.msgBody || { message: data.message }),
            });
        }

        const result = await indexedDb.getImageByKey(imageToken, 'profileimages');
        return {
            title,
            image: window.URL.createObjectURL(result),
            message: updateMessage,
        };
    } catch (error) {
        return {
            title,
            image: isSingleChat(chatType) ? getAvatarImage : groupAvatar,
            message: updateMessage,
        };
    }
};

export const handleUnarchiveChat = (fromUserId, chatType = CHAT_TYPE_SINGLE) => {
    SDK.updateArchiveChat(formatUserIdToJid(fromUserId, chatType), false);
    const dispatchData = {
        fromUserId,
        isArchived: false,
    };
    Store.dispatch(updateArchiveStatusRecentChat(dispatchData));
};

export const handleArchiveActions = async (listenerData = {}) => {
    const {
        msgType = '',
        fromUserId = '',
        chatType = '',
        msgBody: { replyTo = '' } = {},
        editedStatus = 0,
    } = listenerData;
    if (msgType === 'carbonReceiveMessage' || msgType === 'receiveMessage') {
        const chatIds = getArchivedChats(),
            isPermanentArchvie = getArchiveSetting();

        // UnArchive Chat On Receiving New Message - Only for Temporary Archive
        if (fromUserId && chatIds.includes(fromUserId) && !isPermanentArchvie) {
            handleUnarchiveChat(fromUserId, chatType);
        }

        // Send Push If Message is Replied to Current User's Message
        if (replyTo) {
            const mutedChats = getMutedChats();
            if (
                isGroupChat(chatType) &&
                !isActiveConversationUserOrGroup(fromUserId) &&
                !mutedChats.includes(fromUserId)
            ) {
                const orgMsg = await SDK.getMessageById(replyTo, getActiveConversationUserJid());
                if (orgMsg.statusCode === 200 && orgMsg.data) {
                    const { publisherId = '' } = orgMsg.data || {};
                    if (isLocalUser(publisherId) && editedStatus !== 1) {
                        const { title, image, message } = await getPushNotificationData(listenerData);
                        sendNotification(title, image, message, fromUserId);
                    }
                }
            }
        }
    }
};

export const handleTempArchivedChats = (chatJid, chatType) => {
    const archivedChats = getArchivedChats(),
        isPermanentArchvie = getArchiveSetting(),
        chatId = getUserIdFromJid(chatJid);

    if (chatId && archivedChats.includes(chatId) && !isPermanentArchvie) {
        handleUnarchiveChat(chatId, chatType);
    }
};

export const handleUserSettings = async () => {
    const userSettings = await SDK.getUserSettings();
    const webSettings = getLocalWebsettings() || {};
    Store.dispatch(
        webSettingLocalAction({
            isEnableArchived: userSettings?.data?.archive === 1,
            translate: webSettings.translate || false,
        }),
    );
    setLocalWebsettings('archive', userSettings?.data?.archive === 1);
};

export const handleArchivedChats = async () => {
    const archivedChats = await SDK.getAllArchivedChats();
    if (archivedChats.statusCode === 200 && archivedChats.data.length) {
        for (let i in archivedChats.data) {
            const element = archivedChats.data[i];
            element.isArchived = true;
            Store.dispatch(updateArchiveStatusRecentChat(element));
        }
    }
};

export const getRecentChatData = () => {
    const { recentChatData: { data = [] } = {} } = Store.getState();
    return data;
};

export const getMessagesForReport = (chatId, selectedMsgIdType) => {
    const chatMessages = getChatMessageHistoryById(chatId);
    let msgDataArray = [];
    const sortedData = chatMessages
        .filter(item => Object.keys(item.msgBody).length !== 0)
        .sort((a, b) => (b.timestamp < a.timestamp ? -1 : 1));
    if (sortedData.length) {
        let selectedMsgId = selectedMsgIdType !== REPORT_FROM_CONTACT_INFO ? selectedMsgIdType : sortedData[0]?.msgId;
        let count = 0;
        const filteredData = sortedData.filter(msg => {
            if (msg.msgId === selectedMsgId || (count > 0 && count < reportMembers)) {
                count++;
                return msg;
            }
        });
        filteredData.map((item, _key) => {
            let msgObject = {};
            msgObject['msgId'] = item?.msgId || '';
            if (item?.editedStatus === 1) {
                msgObject['message'] = item?.msgBody?.media?.caption
                    ? 'Edited - ' + item?.msgBody?.media?.caption
                    : 'Edited - ' + item?.msgBody?.message;
            } else {
                msgObject['message'] = item?.msgBody?.message || item?.msgBody?.media?.caption || '';
            }
            msgObject['msgType'] = item?.msgBody?.message_type || '';
            msgObject['filename'] = item?.msgBody?.media?.fileName || '';
            msgObject['timestamp'] = item?.timestamp;
            msgObject['publisherId'] = item?.publisherId || item?.fromUserId;
            msgObject['fileSize'] = item?.msgBody?.media?.file_size || '';
            msgObject['fileKey'] = item?.msgBody?.media?.file_key || '';
            msgObject['fileUrl'] = item?.msgBody?.media?.file_url || '';
            msgObject['thumbImage'] = item?.msgBody?.media?.thumb_image || '';
            msgDataArray.push(msgObject);
        });
    } else if (sortedData.length === 0) {
        return msgDataArray;
    }
    return msgDataArray;
};

export const formatMentionedUserHtmlToSpecForm = caption => {
    if (!caption) return caption;

    let temp = document.createElement('div');
    temp.innerHTML = caption;
    let mentionedUiElements = temp.getElementsByClassName('mentioned');
    Array.from(mentionedUiElements).forEach(e => {
        e.innerHTML = '@[?]';
    });
    return temp.textContent || temp.innerText;
};

export function getExtensionWithOutDot(name) {
    if (!name) return '';
    const lastDot = name.lastIndexOf('.');
    return lastDot === -1 ? '' : name.substring(lastDot + 1);
}

function getMimeTypeFromExtension(extension) {
    const mimeTypes = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        mp3: 'audio/mp3',
        wav: 'audio/wav',
        aac: 'audio/aac',
        mpeg: 'audio/mpeg',
        mp4: 'video/mp4',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        pdf: 'application/pdf',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        txt: 'text/plain',
        csv: 'text/csv',
        ppt: 'application/vnd.ms-powerpoint',
        hex: 'application/octet-stream',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        zip: 'application/zip',
        rar: 'application/rar',
        acc: 'audio/acc',
    };
    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
}

export const getDefaultMimeType = file => {
    return file.type || getMimeTypeFromExtension(getExtensionWithOutDot(file.name));
};

export const convertMeridiemTextToSmall = text => {
    if (!text || typeof text !== 'string') return text;
    return text.replace('AM', 'am').replace('PM', 'pm');
};

export const setBodyClass = (className, remove = false) => {
    if (!className) return;
    try {
        if (typeof document !== 'undefined' && document.body) {
            if (remove) {
                if (document.body.classList.contains(className)) {
                    document.body.classList.remove(className);
                }
            } else {
                if (!document.body.classList.contains(className)) {
                    document.body.classList.add(className);
                }
            }
        }
    } catch (err) {
        // ignore DOM errors
    }
};

export const TruncatedFileName = ({ name = '', max = 15 }) => {
    if (!name) return null;
    const display = name.length > max ? `${name.slice(0, max)}...` : name;
    return (
        <span className="truncated-file-name" title={name} aria-label={name}>
            {display}
        </span>
    );
};

export const transformReactionsGrouped = flatReactions => {
    if (!flatReactions || !Array.isArray(flatReactions)) return [];

    // Check if it's already grouped (idempotency check)
    if (flatReactions.length > 0 && flatReactions[0].userIds) {
        return flatReactions;
    }

    const grouped = {};
    flatReactions.forEach(reaction => {
        const { emojiId, reactedUsername, createdTime } = reaction;
        if (!emojiId || !reactedUsername) return;
        if (!grouped[emojiId]) {
            grouped[emojiId] = {
                emojiId,
                userIds: [],
                reactionDetails: [],
            };
        }
        if (!grouped[emojiId].userIds.includes(reactedUsername)) {
            grouped[emojiId].userIds.push(reactedUsername);
            grouped[emojiId].reactionDetails.push({ userId: reactedUsername, time: createdTime });
        }
    });
    return Object.values(grouped);
};

export const updateReactionList = (reactions = [], emojiId, userId, action) => {
    let newReactions = Array.isArray(reactions) ? [...reactions] : [];

    // Always remove existing reaction for this user first to enforce "single reaction per user"
    newReactions = newReactions
        .map(r => ({
            ...r,
            userIds: r.userIds.filter(id => id !== userId),
            reactionDetails: r.reactionDetails ? r.reactionDetails.filter(d => d.userId !== userId) : [],
        }))
        .filter(r => r.userIds.length > 0);

    if (action === 'add' || action === 'update') {
        const existingReactionIndex = newReactions.findIndex(r => r.emojiId === emojiId);
        const newDetail = { userId, time: new Date().toISOString() };

        if (existingReactionIndex > -1) {
            const reaction = { ...newReactions[existingReactionIndex] };
            if (!reaction.userIds.includes(userId)) {
                reaction.userIds = [...reaction.userIds, userId];
                reaction.reactionDetails = [...(reaction.reactionDetails || []), newDetail];
                newReactions[existingReactionIndex] = reaction;
            }
        } else {
            newReactions.push({ emojiId, userIds: [userId], reactionDetails: [newDetail] });
        }
    }
    return newReactions;
};

export const updateMessageReactionHistory = (data, stateData) => {
    const { fromUserId, msgId, emojiId, userId, action } = data;
    const normalizedChatId = fromUserId.includes('@') ? fromUserId.split('@')[0] : fromUserId;
    const currentChatData = stateData[normalizedChatId];

    if (currentChatData?.messages && currentChatData.messages[msgId]) {
        const currentMessage = { ...currentChatData.messages[msgId] };
        currentMessage.reactions = updateReactionList(currentMessage.reactions, emojiId, userId, action);
        currentMessage.lastReactionTime = Date.now() * 1000;

        return {
            ...stateData,
            [normalizedChatId]: {
                ...currentChatData,
                messages: {
                    ...currentChatData.messages,
                    [msgId]: currentMessage,
                },
            },
        };
    }
    return stateData;
};

const _normalizeReactionTimestamp = t => {
    let nt = parseFloat(t);
    if (isNaN(nt) || nt <= 0) return 0;
    if (nt < 10000000000) return nt * 1000000;
    if (nt < 10000000000000) return nt * 1000;
    return nt;
};

export const getMaxReactionTime = reactions => {
    if (!reactions || !Array.isArray(reactions) || reactions.length === 0) return 0;
    let maxTime = 0;
    reactions.forEach(group => {
        const groupTime = _normalizeReactionTimestamp(group.lastReactionTime);
        if (groupTime > maxTime) maxTime = groupTime;
    });
    return maxTime;
};

export const getSummaryMessageForReaction = (messagesArray = []) => {
    if (!messagesArray.length) return null;
    // Filter out invalid/empty messages
    const candidates = messagesArray.filter(m => m && m.msgId);
    if (candidates.length === 0) return null;

    // Return the chronologically newest message
    return candidates.sort((a, b) => {
        const timeA = normalizeTime(a.timestamp);
        const timeB = normalizeTime(b.timestamp);
        return timeB - timeA;
    })[0];
};
